import { SalesPage } from "./SalesPage";

export const Sales = () => {
	return <SalesPage />;
};
